import { createSelector } from 'reselect';
import {products} from "../../../reducers/products";

const getProductSales = state => state.productSales.products;
const getProducts     = state => state.products.products;
const getQuantities   = state => state.productPicker.configurationsQuantityArrays;

const getSelectedValues = state => Object.values(state.productPicker.productsQuantities);
const getSelectedProducts = state => state.productPicker.productsQuantities;
const getConfigQuantities = state => state.productPicker.configQuantities;

export const getProductSalesByEvent = createSelector(
    [getProductSales, getProducts, getQuantities],
    (productSales, products, quantities) => {
        let selectedProducts = {};
        for(var i = 0; i < productSales.length; i++) {
            if (!selectedProducts[productSales[i].event_id]) {
                selectedProducts[productSales[i].event_id] = [{
                    configuration_id: productSales[i].configuration_id,
                    configurationName: productSales[i].display_name,
                    productName: productSales[i].product_name,
                    price: productSales[i].cost.amount,
                    total_price: productSales[i].cost.amount,
                    fee: productSales[i].buyer_fee.amount,
                    total_fee: productSales[i].buyer_fee.amount,
                    quantity: 1,
                    subtotal: productSales[i].cost.amount + productSales[i].buyer_fee.amount,
                    currency: productSales[i].cost.currency,
                    currency_symbol: productSales[i].cost.symbol,
                    event_id: productSales[i].event_id,
                    quantities: quantities[productSales[i].configuration_id],
                    description: productSales[i].description,
                    dependentProduct: productSales[i].dependentProduct
                }];
            }  else {
                let found = false;
                for(var j = 0; j < selectedProducts[productSales[i].event_id].length; j++) {
                    if(selectedProducts[productSales[i].event_id][j].configuration_id === productSales[i].configuration_id) {
                        selectedProducts[productSales[i].event_id][j].total_price += productSales[i].cost.amount;
                        selectedProducts[productSales[i].event_id][j].total_fee += productSales[i].buyer_fee.amount;
                        selectedProducts[productSales[i].event_id][j].subtotal += (productSales[i].cost.amount + productSales[i].buyer_fee.amount);
                        selectedProducts[productSales[i].event_id][j].quantity++;
                        found = true;
                        break;
                    }
                }

                if(!found) {
                    selectedProducts[productSales[i].event_id].push(
                        {
                            configuration_id: productSales[i].configuration_id,
                            configurationName: productSales[i].display_name,
                            productName: productSales[i].product_name,
                            price: productSales[i].cost.amount,
                            total_price: productSales[i].cost.amount,
                            fee: productSales[i].buyer_fee.amount,
                            total_fee: productSales[i].buyer_fee.amount,
                            quantity: 1,
                            subtotal: productSales[i].cost.amount + productSales[i].buyer_fee.amount,
                            currency: productSales[i].cost.currency,
                            currency_symbol: productSales[i].cost.symbol,
                            event_id: productSales[i].event_id,
                            quantities: quantities[productSales[i].configuration_id],
                            description: productSales[i].description,
                            dependentProduct: productSales[i].dependentProduct
                        }
                    );
                }
            }
        }

        return selectedProducts;
    }
);

export const getConfigurationQuantities = createSelector(
    [getProductSales],
    (productSales) => {
        let products = {};
        for(let i = 0; i < productSales.length; i++) {
            if(!products[productSales[i].configuration_id]) {
                products[productSales[i].configuration_id] = 1;
            } else {
                products[productSales[i].configuration_id]++;
            }
        }
        return products;
    }
);

export const getTotalSelectedProducts = createSelector(
    [getSelectedValues],
    (products) => {
        return products.reduce((total, val) => {
            return total + (val === undefined ? 0 : val);
        }, 0);
    }
);

export const cartHasDependentProducts = createSelector(
    [getProductSales],
    (productSales) => {
        let countDependentProducts = 0;
        for(let i = 0; i < productSales.length; i++) {
            if (productSales[i].dependentProduct) {
                countDependentProducts++;
            }
        }

        return (countDependentProducts > 0);
    }
);

export const isDependentProductSelected = createSelector(
    [getProducts, getSelectedProducts],
    (products, selectedProducts) => {
        let dependentIds = [];
        Object.values(products).map((product, i) => {
            if (!product.purchasable_without_tickets) {
                dependentIds.push(product.product_id);
            }
        });

        let countDependentProducts = 0;
        Object.keys(selectedProducts).map(selectedId => {
            if (selectedProducts[selectedId] !== undefined && dependentIds.indexOf(selectedId) !== -1) {
                countDependentProducts++;
            }
        });

        return countDependentProducts > 0;
    }
);

export const getProductsWithErrors = createSelector(
    [getSelectedProducts, getConfigQuantities, getProducts],
    (selectedProducts, configurationQuantities, products) => {
        let  errors = {};
        for (const productId in selectedProducts) {
            if (selectedProducts[productId] !== undefined &&
                (configurationQuantities[productId] === undefined ||
                    selectedProducts[productId] !== Object.keys(configurationQuantities[productId]).length)) {
                if (!errors[productId]) {
                    errors[productId] = [{
                        productId: products[productId].product_id,
                        productName: products[productId].name,
                        optionName: products[productId].configurations[0].optionName,
                    }];
                }
            }
        }

        return errors;
    }
);
